import { getApi, postApi, putApiWithoutId } from '../../Shared/Services/RestService';
import {
  Alert,
  Incident,
  LogEntry,
  MonitoringConfig,
  Operation,
  ServiceActionRequest,
  ServiceStatus,
  SystemHealthOverview,
  SystemMetrics,
} from '../Types/SystemHealthType';

const BASE = '/admin/system-health';

export const getSystemHealthOverview = () => {
  return getApi<SystemHealthOverview>(`${BASE}/overview`);
};

export const getSystemHealthServices = () => {
  return getApi<ServiceStatus[]>(`${BASE}/services`);
};

export const getServiceStatus = (serviceId: string) => {
  return getApi<ServiceStatus>(`${BASE}/services/${serviceId}/status`);
};

export const getServiceLogs = (
  serviceId: string,
  lines = 200,
  since?: string,
  severity?: string,
  search?: string
) => {
  const params: Record<string, unknown> = { lines };
  if (since) params.since = since;
  if (severity) params.severity = severity;
  if (search) params.search = search;
  return getApi<LogEntry[]>(`${BASE}/services/${serviceId}/logs`, params);
};

export const submitServiceAction = (serviceId: string, payload: ServiceActionRequest) => {
  return postApi<Operation>(`${BASE}/services/${serviceId}/actions`, payload);
};

export const getOperation = (operationId: string) => {
  return getApi<Operation>(`${BASE}/operations/${operationId}`);
};

export const getSystemMetrics = () => {
  return getApi<SystemMetrics>(`${BASE}/metrics`);
};

export const getIncidents = () => {
  return getApi<Incident[]>(`${BASE}/incidents`);
};

export const getIncident = (incidentId: string) => {
  return getApi<Incident>(`${BASE}/incidents/${incidentId}`);
};

export const getMonitoringConfig = () => {
  return getApi<MonitoringConfig>(`${BASE}/monitoring-config`);
};

export const updateMonitoringConfig = (payload: MonitoringConfig) => {
  return putApiWithoutId<MonitoringConfig>(`${BASE}/monitoring-config`, payload);
};

export const testAlert = () => {
  return postApi<{ status: string; sent: number; failed: number }>(`${BASE}/alerts/test`, {});
};

export const getAlerts = () => {
  return getApi<Alert[]>(`${BASE}/alerts`);
};
